import { jsxs, jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { StyledLabel, StyledSwitch } from "./styles.js";
import { inheritDataTestId } from "../../utils/dataTestId.js";
const Toggle = ({
  labelLeft,
  labelRight,
  ...props
}) => /* @__PURE__ */ jsxs(
  Stack,
  {
    direction: "row",
    spacing: "18px",
    alignItems: "center",
    "data-test-id": inheritDataTestId(props, "toggle-container"),
    children: [
      labelLeft && /* @__PURE__ */ jsx(StyledLabel, { variant: "14_18_500", children: labelLeft }),
      /* @__PURE__ */ jsx(StyledSwitch, { ...props }),
      labelRight && /* @__PURE__ */ jsx(StyledLabel, { variant: "14_18_500", children: labelRight })
    ]
  }
);
export {
  Toggle
};
//# sourceMappingURL=Toggle.js.map
